import { Button, Card, Col, Form, Table } from "react-bootstrap";
import { CamposObrigatorios, JConfirmDelete, JRow, MakeMessageError, MensagemModal } from "../../../components/Components";
import { formatMoeda, getUuidV4, goToFocus, handleNumberOnly } from "../../../utils/utils";
import { SelectObjectRemoveInterface, VagaoInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { changeModalFerroviarioTrem, clearError } from "../../../features/manifestoSlice";
import { Link } from "react-router-dom";
import { addVagao, removeVagao } from "../../../features/manifestoSlice";

const initialFormVagao: VagaoInterface = {
    id: 0,
    nseq: '',
    nvag: '',
    pesobc: 0,
    pesor: 0,
    serie: '',
    tpvag: '',
    tu: 0
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function Trem() {
    const dispatch = useDispatch();
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const form = useSelector((state: RootState) => state.manifesto.manifesto.modal_ferroviario.trem);
    const listaVagoes = useSelector((state: RootState) => state.manifesto.manifesto.modal_ferroviario.vag);
    const [formVagao, setFormVagao] = useState<VagaoInterface>(initialFormVagao);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const pesoBcRef = useRef<HTMLInputElement>(null)
    const pesoRealRef = useRef<HTMLInputElement>(null)
    const serieRef = useRef<HTMLInputElement>(null)
    const nVagaoRef = useRef<HTMLInputElement>(null)
    const toneladaUtilRef = useRef<HTMLInputElement>(null)


    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }


    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleChangeTrem = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeModalFerroviarioTrem({ [name]: value }));
        dispatch(clearError('modal_ferroviario_trem_' + name))
    }

    const handleAddVag = () => {
        if (validarPreenchimento()) {
            dispatch(addVagao({
                ...formVagao,
                id: getUuidV4()
            }));
            setFormVagao(initialFormVagao);
        }
    }

    const validarPreenchimento = () => {
        if (formVagao.pesobc === 0 || formVagao.pesobc.toString().trim() === "") {
            alerta('Informe Peso Base (Frete) Ton.');
            goToFocus(pesoBcRef);
            return false;
        }

        if (formVagao.pesor === 0 || formVagao.pesor.toString().trim() === "") {
            alerta('Informe Peso Real Ton.');
            goToFocus(pesoRealRef);
            return false;
        }

        if (formVagao.serie.trim() === "") {
            alerta("Informe a série.");
            goToFocus(serieRef);
            return false;
        }

        if (formVagao.nvag.trim() === "") {
            alerta("Informe o número do vagão.");
            goToFocus(nVagaoRef);
            return false;
        }

        if (formVagao.tu === 0 || formVagao.tu.toString().trim() === "") {
            alerta('Informe a Tonelada Útil');
            goToFocus(toneladaUtilRef);
            return false;
        }

        if (listaVagoes.find((item: VagaoInterface) => item.nvag.trim() === formVagao.nvag.trim())) {
            alerta('Número de vagão já adicionado.');
            goToFocus(nVagaoRef);
            return false;
        }

        return true;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormVagao((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleRemover = (id: number) => {
        dispatch(removeVagao(id))
        setShowModal(false);
    }

    return (<div className="px-2 g-3">

        <Card className="card-primary card-outline mb-2">
            <Card.Header>
                Informações da composição do trem
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group>
                            <Form.Label>* Prefixo do trem</Form.Label>
                            <Form.Control type="text" name="xpref" maxLength={10} value={form.xpref}
                                className={`${errors.modal_ferroviario_trem_xpref?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xpref" />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>
                        <Form.Group>
                            <Form.Label>Dt/Hr. Lib.</Form.Label>
                            <Form.Control type="datetime-local" name="dhtrem" maxLength={21} value={form.dhtrem}
                                className={`${errors.modal_ferroviario_trem_dhtrem?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_dhtrem" />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Qtd. Vagões</Form.Label>
                            <Form.Control type="number" name="qvag" maxLength={3}
                                className={`${errors.modal_ferroviario_trem_qvag?.length > 0 ? "is-invalid" : ""}`}
                                value={form.qvag}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_qvag" />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Origem do Trem</Form.Label>
                            <Form.Control type="text" name="xori" maxLength={3} value={form.xori}
                                className={`${errors.modal_ferroviario_trem_xori?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xori" />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>* Destino do trem</Form.Label>
                            <Form.Control type="text" name="xdest" maxLength={3} value={form.xdest}
                                className={`${errors.modal_ferroviario_trem_xdest?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xdest" />
                        </Form.Group>
                    </Col>
                </JRow>

            </Card.Body>
        </Card>

        <Card className="card-primary card-outline">
            <Card.Header>
                Informações dos Vagões <span className="text-danger">(Obs: Adicionar pelo menos um vagão)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group>
                            <Form.Label className="">* Peso Base (Frete) Ton.</Form.Label>
                            <Form.Control type="number" name="pesobc" value={formVagao.pesobc} ref={pesoBcRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]: value.replace(/[^0-9.]/g, "")
                                            .replace(/^(\d{0,3})\d*/, "$1")
                                            .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>* Peso Real Ton.</Form.Label>
                            <Form.Control type="number" name="pesor" value={formVagao.pesor} ref={pesoRealRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]:
                                            value.replace(/[^0-9.]/g, "")
                                                .replace(/^(\d{0,3})\d*/, "$1")
                                                .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>Tipo de Vagão</Form.Label>
                            <Form.Control type="text" name="tpvag" maxLength={3} value={formVagao.tpvag}
                                onChange={handleChange}

                            />
                        </Form.Group>
                    </Col>

                </JRow>

                <JRow className="mb-3">
                    <Col md>
                        <Form.Group>
                            <Form.Label>* Série</Form.Label>
                            <Form.Control type="text" name="serie" maxLength={3} value={formVagao.serie}
                                ref={serieRef}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>* Núm. Vagão</Form.Label>
                            <Form.Control type="text" name="nvag" maxLength={8} value={formVagao.nvag}
                                ref={nVagaoRef}
                                onChange={handleChange} onKeyUp={handleNumberOnly}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>Sequência</Form.Label>
                            <Form.Control type="text" name="nseq" maxLength={3} value={formVagao.nseq}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Tonelada Ùtil</Form.Label>
                            <Form.Control type="number" name="tu" value={formVagao.tu} ref={toneladaUtilRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]:
                                            value.replace(/[^0-9.]/g, "")
                                                .replace(/^(\d{0,3})\d*/, "$1")
                                                .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">

                        <Form.Group className="">

                            <Button variant="primary" onClick={handleAddVag}>
                                <FontAwesomeIcon icon={faPlus} />  Adicionar
                            </Button>
                        </Form.Group>
                    </Col>

                </JRow>

                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Série</th>
                            <th className="text-center" style={{ width: '7rem' }}>Num. Vagão</th>
                            <th className="text-center" >Peso Base Frete T.</th>
                            <th className="text-center">Peso Real T.</th>
                            <th className="text-center">Tonelada útil</th>

                        </tr>
                    </thead>

                    <tbody>
                        {listaVagoes?.map((item: VagaoInterface) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger"
                                        onClick={() => handleOpenModal({ id: item.id, title: item.nvag })}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Link>
                                </td>
                                <td className="text-center">{item.serie}</td>
                                <td className="text-center">{item.nvag}</td>
                                <td className="text-center">{formatMoeda(item.pesobc, 3)}</td>
                                <td className="text-center">{formatMoeda(item.pesor, 3)}</td>
                                <td className="text-center">{formatMoeda(item.tu, 3)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </div>)
}